import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Label
name: Label
category: React - Bulma
---

A `Label` component based on Bulma `.label`. This is a wrapper for the `<label>`
tag. It should be used inside a `Field` component alongside an input component.
Be sure to use `htmlFor={inputName}` so that when the label is clicked, the
input will have focus.

If you're trying to build a form, take a look at the different field components.
Using those will help ensure consistency.

See [Bulma Documentation](http://bulma.io/documentation/form/general/#form-field) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| size            | Input label size.                             | string         |                           | no            |

```html_example
  <form>
    <Field>
      <Label htmlFor="example">Input name</Label>
      <Control>
        <Input name="example" type="text" onChange={onChangeHandler} />
      </Control>
    </Field>
  </form>
```
*/
function Label(props) {
  const {
    className, children, size, ...rest
  } = props

  // @TODO Fix css to be Bulma's default of `.label` once Bootstrap is no longer a dependency.
  const classes = [
    'bulma-migration bulma-label',
    size ? `is-${size}` : '',
    className || '',
  ]

  return (
    <label {...rest} className={classes.join(' ')}>
      {children}
    </label>
  )
}

Label.propTypes = {
  // Input label size.
  size: PropTypes.string,
}

export default Label
